import React from 'react';
import Button from '@material-ui/core/Button';
import { Dropdown, Grid, Input, Form, TextArea, Checkbox } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import Buttons from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import $ from "jquery";
import Loading from '../../loadings';

class AddEditCustomer extends React.Component {

    state = {
        addEditCustomer: false, stateOption: [], districtOption: [], talukOption: [], id: 0, 
        selectedModel: [], tcs: 0, credit_limit: 0, discountOption: []
    }

    editCustomer() {
        if (!this.props.menuPermission.edit) { 
            alert('You Are Not Allow To Access!!!!'); return; 
        }

        let model = this.props.item.model;
        try {
            model = model.split(',');
        } catch (error) {
        }
        this.setState({
            gst: this.props.item.GSTIN, address: this.props.item.address, id: this.props.item.id,
            machine: this.props.item.machine, district: this.props.item.district, pincode: this.props.item.pincode,
            state: this.props.item.state, tcs: this.props.item.tcs, taluk: this.props.item.taluk, 
            selectedModel: model, selectedCustomerType: this.props.item.type, name: this.props.item.name, 
            mobile: this.props.item.mobile, altmobile: this.props.item.alt_mobile, 
            status: this.props.item.status, discount_level: this.props.item.discount_level,
            whatsappmobile: this.props.item.whatsapp, mail: this.props.item.email_id,
            date: this.props.item.dob, credit_limit: this.props.item.limit_bal, addEditCustomer: true, 
            talukOption: this.props.taluk, districtOption: this.props.district, state_code: this.props.item.state_code,
            stateOption: this.props.state, modelOption: this.props.model, discountOption: this.props.discount
        })
    }

    selectCustomerType = (f, { value }) => { this.setState({ selectedCustomerType: value }) }

    selectModel = (f, { value }) => { this.setState({ selectedModel: value }) }

    selectState = (f, { value }) => { this.setState({ state: value }) }

    selectStatus = (f, { value }) => { this.setState({ status: value }) }

    selectDistrict = (f, { value }) => { this.setState({ district: value }) }

    selectTaluk = (f, { value }) => { this.setState({ taluk: value }) }

    selectdiscount = (f, { value }) => { this.setState({ discount_level: value }) }

    handleDistrictAddition = (e, { value }) => {
        let districtOption = this.state.districtOption;
        districtOption.push({ key: value, text: value, value: value });
        this.setState({ districtOption })
    }

    handleStateAddition = (e, { value }) => {
        let stateOption = this.state.stateOption;
        stateOption.push({ key: value, text: value, value: value });
        this.setState({ stateOption })
    }

    handleTalukAddition = (e, { value }) => {
        let talukOption = this.state.talukOption;
        talukOption.push({ key: value, text: value, value: value });
        this.setState({ talukOption })
    }

    machinenumberConvertStringToArray(machine_no) {
        try {
            machine_no = machine_no.split(',');
        } catch (e) {
            machine_no = [];
        }
        return machine_no;
    }

    submit() {
        let context = this;
        let { tcs, gst, address, status, id, machine, district, discount_level, credit_limit, discountOption, state_code, pincode, state, taluk, selectedModel, selectedCustomerType, name, mobile, altmobile, whatsappmobile, mail, date } = this.state;
        let cook = (ReadCookie("vaigai"));
        let ExecutiveId = cook.id;
        machine = this.machinenumberConvertStringToArray(machine);
        let data = { tcs, id, ExecutiveId, gst, address, machine, district, pincode, state, taluk, 
                     selectedModel, selectedCustomerType, name, mobile, altmobile, whatsappmobile, status,
                     mail, date, credit_limit, 'type': this.props.from, discount_level, state_code };
       
        let url = Server() + 'WebMaster/AddCustomer/AddCustomerDetails.php';
        this.setState({ load: true, message: 'Loading!!!' })
        $.ajax({
            type: 'POST', url, data,
            success: function(data) {
                console.log(data);
                if (data == 1) {
                    if (context.props.from == 'Edit') {
                        let customers = context.props.customers;
                        customers.map((c) => {
                            if (c.id == id) {
                                c.GSTIN = context.state.gst; c.address = context.state.address;
                                c.district = context.state.district; c.pincode = context.state.pincode;
                                c.state = context.state.state; c.tcs = context.state.tcs;
                                c.taluk = context.state.taluk; c.name = context.state.name;
                                c.mobile = context.state.mobile; c.altmobile = context.state.altmobile;
                                c.whatsapp = context.state.whatsappmobile; c.email_id = context.state.mail;
                                c.dob = context.state.date; c.whatsapp = context.state.whatsappmobile;
                                c.whatsapp = context.state.whatsappmobile; c.machine = context.state.machine;
                                c.selectedCustomerType = context.state.type; c.status = context.state.status;
                                c.state_code = context.state.state_code;
                            }
                        })
                        context.setState({ addEditCustomer: false, load: false })
                        context.props.getCustomer();
                    }
                    else {
                        context.setState({ addEditCustomer: false, load: false })
                        context.props.getCustomer();
                        alert(data)
                    }
                }
                else {
                    alert('Error!!!!');
                    context.setState({ load: false })
                }
                
            },
            error: function(e) {
                alert(e)
                context.setState({ load: false });
            }
        });
    } 

    handleChange1 = (tcs) => event => { 
        if (tcs == 0 || tcs == '0') { tcs = 1; }
        else { tcs = 0; }
        this.setState({ tcs })
    }

    render() {
        let { addEditCustomer, discountOption, discount_level, gst, state_code, status, tcs, address, machine, credit_limit, district, pincode, talukOption, districtOption, stateOption, state, taluk, selectedModel, selectedCustomerType, name, mobile, altmobile, whatsappmobile, mail, date } = this.state;
        let statusOption = [
            { key: 'Active', text: 'Active', value: 'Active' },
            { key: 'Inactive', text: 'Inactive', value: 'Inactive' },
            { key: 'New', text: 'New', value: 'New' },
        ]
        return (
            <div>
                <Loading load={this.state.load} message={this.state.message} />
                { this.props.from == 'Add' ?
                    <Button onClick={ () => { if (!this.props.menuPermission.add) { alert('You Are Not Allow To Access!!!!'); return; }this.setState({ talukOption: this.props.taluk, districtOption: this.props.district, discountOption: this.props.discount, stateOption: this.props.state, addEditCustomer: true, modelOption: this.props.model,  }) } } fullWidth variant="outlined">ADD</Button>:
                    <center onClick={this.editCustomer.bind(this)}><u>Edit</u></center>
                }
                <Dialog fullWidth={true} maxWidth={'lg'} open={addEditCustomer} aria-labelledby="responsive-dialog-title">
                    <DialogTitle id="responsive-dialog-title" id="widthdialog">{"ADD / EDIT CUSTOMER"}</DialogTitle>
                    <DialogContent>
                        <Grid>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Name</b><br />
                                <Input fluid focus placeholder='Name' value={name}
                                    onChange={ event => { this.setState({ name: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Mobile</b><br />
                                <Input fluid focus placeholder='Mobile' value={mobile}
                                    onChange={ event => { this.setState({ mobile: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Alt. Mobile</b><br />
                                <Input fluid focus placeholder='Alt. Mobile' value={altmobile}
                                    onChange={ event => { this.setState({ altmobile: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>WhatsApp. Mobile</b><br />
                                <Input fluid focus placeholder='WhatsApp Mobile' value={whatsappmobile}
                                    onChange={ event => { this.setState({ whatsappmobile: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Email</b><br />
                                <Input fluid focus placeholder='Email' value={mail}
                                    onChange={ event => { this.setState({ mail: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>DOB</b><br />
                                <input type="date" style={{width: '100%', height: 35 }} value={date}
                                    onChange={ event => { this.setState({ date: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>GSTIN</b><br />
                                <Input fluid focus placeholder='GSTIN' value={gst}
                                    onChange={ event => { this.setState({ gst: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Machine</b><br />
                                <Input fluid focus placeholder='Machine' value={machine}
                                    onChange={ event => { this.setState({ machine: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={6} tablet={8}>
                                <b>Customer Type</b><br />
                                <Dropdown fluid placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectCustomerType}
                                    options={this.props.customerType} value={selectedCustomerType} />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={6} tablet={8}>
                                <b>Model</b><br />
                                <Dropdown fluid placeholder='Executive' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search multiple selection onChange={this.selectModel}
                                    options={this.state.modelOption} value={selectedModel} />
                            </Grid.Column>
                            <Grid.Column mobile={8} computer={4} tablet={8}>
                                <b>Credit Limit</b><br/>
                                <Input label='Rs.' fluid focus placeholder='Credit Limit' value={credit_limit}
                                    onChange={ event => { this.setState({ credit_limit: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={16} computer={16} tablet={16}>
                                <Form>
                                    <b>Address</b><br/>
                                    <TextArea fluid placeholder='Address' value={address}
                                    onChange={ event => { this.setState({ address: event.target.value }) } } />
                                </Form>
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={3} tablet={4}>
                                <b>Taluk</b><br />
                                <Dropdown fluid placeholder='Taluk' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectTaluk} allowAdditions
                                    onAddItem={this.handleTalukAddition}
                                    options={talukOption} value={taluk} />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={3} tablet={3}>
                                <b>District</b><br />
                                <Dropdown fluid placeholder='District' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectDistrict} allowAdditions
                                    onAddItem={this.handleDistrictAddition}
                                    options={districtOption} value={district} />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={3} tablet={3}>
                                <b>State</b><br />
                                <Dropdown fluid placeholder='State' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectState} allowAdditions
                                    onAddItem={this.handleStateAddition}
                                    options={stateOption} value={state} />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={2} tablet={3}>
                                <b>Pincode</b><br />
                                <Input fluid focus placeholder='Pincode' value={pincode}
                                    onChange={ event => { this.setState({ pincode: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={2} tablet={3}>
                                <b>State Code</b><br />
                                <Input fluid focus placeholder='State Code' value={state_code}
                                    onChange={ event => { this.setState({ state_code: event.target.value }) } } />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={3} tablet={3}>
                                <b>Status</b><br />
                                <Dropdown fluid placeholder='Status' style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectStatus} allowAdditions 
                                    options={statusOption} value={status} />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={4}>
                                <b>Discount Price Level</b><br />
                                <Dropdown fluid placeholder='Discount Price Level' 
                                    style={{ borderColor: '#5A9CBB', fontSize: 12.5 }}
                                    search selection onChange={this.selectdiscount} 
                                    options={discountOption} value={discount_level} />
                            </Grid.Column>
                            <Grid.Column mobile={4} computer={4} tablet={3}>
                                <Checkbox onChange={this.handleChange1(tcs)} checked={tcs == 0 || tcs == '0' ? false : true} />
                                TCS
                            </Grid.Column>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Buttons onClick={ () => { this.setState({ addEditCustomer: false }) }} variant="outlined" 
                            color="secondary">Close</Buttons>
                        <Buttons onClick={this.submit.bind(this)} variant="outlined" 
                            color="secondary">Submit</Buttons>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

export default AddEditCustomer;
